import * as React from "react";
import { FeedItemTag } from "../../../server/feed/buildfeed";
import { FeedElementContainer } from "../DesignSystem/formatting/FeedComponents";
import { LinkToUser } from "../DesignSystem/LinkToUser";
import { RLink } from "../DesignSystem/RLink";
import { slugify } from "../models/tags";

export const FeedElementNewTag = ({ item }: { item: FeedItemTag }) => {
  return (
    <FeedElementContainer
      href={`/entry/${item.entry_id}`}
      compact
      icon={"tag"}
      avatars={[{ username: item.username, avatar_url: item.avatar_url }]}
      title={
        <>
          <LinkToUser linkUser={{ username: item.username }} />
          <span className="text-slate-500 dark:text-slate-400">
            {" "}
            and others tagged{" "}
          </span>
          <RLink white to={"/entry/" + item.entry_id}>
            {item.title}
          </RLink>
          <span className="text-slate-500 dark:text-slate-400"> as </span>
          {item.tags.map((tag, i) => (
            <span key={tag}>
              <RLink white to={`/tag/${slugify(tag)}`}>
                {tag}
              </RLink>
              {i < item.tags.length - 1 ? ", " : ""}
            </span>
          ))}
        </>
      }
    ></FeedElementContainer>
  );
};
